<template>
  <div>
    <v-toolbar flat dark>
      <v-list>
        <v-list-item>
          <v-list-item-title class="subtitle-1 pl-4 font-weight-bold"> - Admin</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-toolbar>


















    <v-list>
      <template v-for="item in items"
        >
  
      </template>
      <v-list-group
        :prepend-icon="item.action"
        no-action
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="subItem in item.items"
          :key="subItem.title"
          @click=""
        >
          <v-list-item-content>
            <v-list-item-title v-text="subItem.title"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
  </div>
</template>

<!--
  <v-list>
    <v-list-group
  </v-list>
-->





















<script>
  export default {
    data () {
      return {
        items: [
          {
            action: 'local_activity',
            title: 'Attractions',
            items: [
              { title: 'List Item' },
            ],
          },
          {
            action: 'restaurant',
            title: 'Dining',
            type: 'group',
            items: [
              { title: 'Breakfast & brunch' },
              { title: 'New American' },
              { title: 'Sushi' },
            ],
          },
          {
            action: 'school',
            title: 'Education',
            type: 'group',
            items: [
              { title: 'AAAA' },
            ],
          },
          {
            action: 'school',
            title: 'not a group',
            type: 'notgroup',
            items: [
              
            ],
          },
          {
            action: 'directions_run',
            title: 'Family',
            items: [
              { title: 'ssssm' },
            ],
          },
          {
            action: 'healing',
            title: 'Health',
            items: [
              { title: 'Lisddddem' },
            ],
          },
          {
            action: 'content_cut',
            title: 'Office',
            items: [
              { title: 'List Item' },
            ],
          },
          {
            action: 'local_offer',
            title: 'Promotions',
            items: [
              { title: 'List Item' },
            ],
          },
        ],
      }
    },
  }
</script>